import Utils from '@/utils/index';

const purchaseList = new Map([
  [
    'ar',
    new Map([
      [
        'weekly',
        {
          price: '$3.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$3.99',
          key: 'week',
        },
      ],
      [
        'monthly',
        {
          price: '$7.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$1.99',
          key: 'month',
        },
      ],
      [
        'yearly',
        {
          price: '$47.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$0.99',
          key: 'year',
        },
      ],
    ]),
  ],
  [
    'br',
    new Map([
      [
        'weekly',
        {
          price: 'R$19.99',
          currency: 'R$',
          currencyArea: 'BRL',
          perWeek: 'R$19.9',
          key: 'week',
        },
      ],
      [
        'monthly',
        {
          price: 'R$39.99',
          currency: 'R$',
          currencyArea: 'BRL',
          perWeek: 'R$9.99',
          key: 'month',
        },
      ],
      [
        'yearly',
        {
          price: 'R$242.99',
          currency: 'R$',
          currencyArea: 'BRL',
          perWeek: 'R$4.99',
          key: 'year',
        },
      ],
    ]),
  ],
  [
    'cn',
    new Map([
      [
        'weekly',
        {
          price: '$3.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$3.99',
          key: 'week',
        },
      ],
      [
        'monthly',
        {
          price: '$7.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$1.99',
          key: 'month',
        },
      ],
      [
        'yearly',
        {
          price: '$47.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$0.99',
          key: 'year',
        },
      ],
    ]),
  ],
  [
    'de',
    new Map([
      [
        'weekly',
        {
          price: '3.99€',
          currency: '€',
          currencyArea: 'EUR',
          perWeek: '3.99€',
          key: 'week',
        },
      ],
      [
        'monthly',
        {
          price: '7.99€',
          currency: '€',
          currencyArea: 'EUR',
          perWeek: '1.99€',
          key: 'month',
        },
      ],
      [
        'yearly',
        {
          price: '47.99€',
          currency: '€',
          currencyArea: 'EUR',
          perWeek: '0.99€',
          key: 'year',
        },
      ],
    ]),
  ],
  [
    'es',
    new Map([
      [
        'weekly',
        {
          price: '3.99€',
          currency: '€',
          currencyArea: 'EUR',
          perWeek: '3.99€',
          key: 'week',
        },
      ],
      [
        'monthly',
        {
          price: '7.99€',
          currency: '€',
          currencyArea: 'EUR',
          perWeek: '1.99€',
          key: 'month',
        },
      ],
      [
        'yearly',
        {
          price: '47.99€',
          currency: '€',
          currencyArea: 'EUR',
          perWeek: '0.99€',
          key: 'year',
        },
      ],
    ]),
  ],
  [
    'en',
    new Map([
      [
        'weekly',
        {
          price: '$3.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$3.99',
          key: 'week',
        },
      ],
      [
        'monthly',
        {
          price: '$7.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$1.99',
          key: 'month',
        },
      ],
      [
        'yearly',
        {
          price: '$47.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$0.99',
          key: 'year',
        },
      ],
    ]),
  ],
  [
    'fr',
    new Map([
      [
        'weekly',
        {
          price: '3.99€',
          currency: '€',
          currencyArea: 'EUR',
          perWeek: '3.99€',
          key: 'week',
        },
      ],
      [
        'monthly',
        {
          price: '7.99€',
          currency: '€',
          currencyArea: 'EUR',
          perWeek: '1.99€',
          key: 'month',
        },
      ],
      [
        'yearly',
        {
          price: '47.99€',
          currency: '€',
          currencyArea: 'EUR',
          perWeek: '0.99€',
          key: 'year',
        },
      ],
    ]),
  ],
  [
    'id',
    new Map([
      [
        'weekly',
        {
          price: '$3.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$3.99',
          key: 'week',
        },
      ],
      [
        'monthly',
        {
          price: '$7.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$1.99',
          key: 'month',
        },
      ],
      [
        'yearly',
        {
          price: '$47.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$0.99',
          key: 'year',
        },
      ],
    ]),
  ],
  [
    'in',
    new Map([
      [
        'weekly',
        {
          price: '$3.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$3.99',
          key: 'week',
        },
      ],
      [
        'monthly',
        {
          price: '$7.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$1.99',
          key: 'month',
        },
      ],
      [
        'yearly',
        {
          price: '$47.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$0.99',
          key: 'year',
        },
      ],
    ]),
  ],
  [
    'it',
    new Map([
      [
        'weekly',
        {
          price: '3.99€',
          currency: '€',
          currencyArea: 'EUR',
          perWeek: '3.99€',
          key: 'week',
        },
      ],
      [
        'monthly',
        {
          price: '7.99€',
          currency: '€',
          currencyArea: 'EUR',
          perWeek: '1.99€',
          key: 'month',
        },
      ],
      [
        'yearly',
        {
          price: '47.99€',
          currency: '€',
          currencyArea: 'EUR',
          perWeek: '0.99€',
          key: 'year',
        },
      ],
    ]),
  ],
  [
    'jp',
    new Map([
      [
        'weekly',
        {
          price: '550円',
          currency: '円',
          currencyArea: 'JPY',
          perWeek: '550円',
          key: 'week',
        },
      ],
      [
        'monthly',
        {
          price: '1,000円',
          currency: '円',
          currencyArea: 'JPY',
          perWeek: '275円',
          key: 'month',
        },
      ],
      [
        'yearly',
        {
          price: '6,200円',
          currency: '円',
          currencyArea: 'JPY',
          perWeek: '142円',
          key: 'year',
        },
      ],
    ]),
  ],
  [
    'kr',
    new Map([
      [
        'weekly',
        {
          price: '₩5,399',
          currency: '₩',
          currencyArea: 'KRW',
          perWeek: '₩5399',
          key: 'week',
        },
      ],
      [
        'monthly',
        {
          price: '₩10,999',
          currency: '₩',
          currencyArea: 'KRW',
          perWeek: '₩2699',
          key: 'month',
        },
      ],
      [
        'yearly',
        {
          price: '₩64,999',
          currency: '₩',
          currencyArea: 'KRW',
          perWeek: '₩1399',
          key: 'year',
        },
      ],
    ]),
  ],
  [
    'nl',
    new Map([
      [
        'weekly',
        {
          price: '3.99€',
          currency: '€',
          currencyArea: 'EUR',
          perWeek: '3.99€',
          key: 'week',
        },
      ],
      [
        'monthly',
        {
          price: '7.99€',
          currency: '€',
          currencyArea: 'EUR',
          perWeek: '1.99€',
          key: 'month',
        },
      ],
      [
        'yearly',
        {
          price: '47.99€',
          currency: '€',
          currencyArea: 'EUR',
          perWeek: '0.99€',
          key: 'year',
        },
      ],
    ]),
  ],
  [
    'ru',
    new Map([
      [
        'weekly',
        {
          price: '$3.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$3.99',
          key: 'week',
        },
      ],
      [
        'monthly',
        {
          price: '$7.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$1.99',
          key: 'month',
        },
      ],
      [
        'yearly',
        {
          price: '$47.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$0.99',
          key: 'year',
        },
      ],
    ]),
  ],
  [
    'tr',
    new Map([
      [
        'weekly',
        {
          price: '$3.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$3.99',
          key: 'week',
        },
      ],
      [
        'monthly',
        {
          price: '$7.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$1.99',
          key: 'month',
        },
      ],
      [
        'yearly',
        {
          price: '$47.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$0.99',
          key: 'year',
        },
      ],
    ]),
  ],
  [
    'tw',
    new Map([
      [
        'weekly',
        {
          price: '$3.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$3.99',
          key: 'week',
        },
      ],
      [
        'monthly',
        {
          price: '$7.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$1.99',
          key: 'month',
        },
      ],
      [
        'yearly',
        {
          price: '$47.99',
          currency: '$',
          currencyArea: 'USD',
          perWeek: '$0.99',
          key: 'year',
        },
      ],
    ]),
  ],
]);
let lang = Utils.getLanguage();
lang = lang === 'inn' ? 'in' : lang === 'tk' ? 'tr' : lang;
export default purchaseList.get(lang);
